var localeToSelect;
var flatPickrObject;

switch (window.greenmotion.locale) {
    case 'es':
        flatPickrObject = require('flatpickr/dist/l10n/es');
        localeToSelect = flatPickrObject.Spanish;
        break;
    case 'de':
        flatPickrObject = require('flatpickr/dist/l10n/de');
        localeToSelect = flatPickrObject.German;
        break;
    case 'fr':
        flatPickrObject = require('flatpickr/dist/l10n/fr');
        localeToSelect = flatPickrObject.French;
        break;
    case 'hr':
        flatPickrObject = require('flatpickr/dist/l10n/hr');
        localeToSelect = flatPickrObject.Croatian;
        break;
    case 'it':
        flatPickrObject = require('flatpickr/dist/l10n/it');
        localeToSelect = flatPickrObject.Italian;
        break;
    case 'lv':
        flatPickrObject = require('flatpickr/dist/l10n/lv');
        localeToSelect = flatPickrObject.Latvian;
        break;
    case 'mk':
        flatPickrObject = require('flatpickr/dist/l10n/mk');
        localeToSelect = flatPickrObject.Macedonian;
        break;
    case 'mx':
        flatPickrObject = require('flatpickr/dist/l10n/es');
        localeToSelect = flatPickrObject.Spanish;
        break;
    case 'nl':
        flatPickrObject = require('flatpickr/dist/l10n/nl');
        localeToSelect = flatPickrObject.Dutch;
        break;
    case 'pl':
        flatPickrObject = require('flatpickr/dist/l10n/pl');
        localeToSelect = flatPickrObject.Polish;
        break;
    case 'rs':
        flatPickrObject = require('flatpickr/dist/l10n/sr');
        localeToSelect = flatPickrObject.Serbian;
        break;
    case 'fi':
        flatPickrObject = require('flatpickr/dist/l10n/fi');
        localeToSelect = flatPickrObject.Finnish;
        break;
    case 'tr':
        flatPickrObject = require('flatpickr/dist/l10n/tr');
        localeToSelect = flatPickrObject.Turkish;
        break;
    default:
        flatPickrObject = require('flatpickr/dist/l10n/default');
        localeToSelect = flatPickrObject.english;
}

export {localeToSelect}
